module.exports = __webpack_public_path__ + "static/media/appstore-badge.c4e39986.svg";